import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import React from 'react';
import {Atom} from '@packages/systems/wfdl';
import {createRgbaColor} from '@packages/systems/core/utils/ColorUtils';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {EvaluatedNodeData, getChildren} from '@packages/utilities/data-utils';

const BlockContent = Atom.createRender(
  ({attributes, classes, data, generateAttributes, renderChild}) => (
    <fieldset {...generateAttributes(attributes, classes)}>
      {getChildren(data).map((child: EvaluatedNodeData) => renderChild(child))}
    </fieldset>
  )
);

const config = createIntegratedAtom({
  displayName: 'Block Content',
  showEmpty: true,
  style: {
    base: {
      main: {
        noPseudo: {
          paddingTop: px(20),
          paddingBottom: px(20),
          paddingRight: px(20),
          paddingLeft: px(20),
          borderBottomStyle: 'solid',
          borderBottomWidth: px(1),
          borderBottomColor: createRgbaColor('e6e6e6'),
          borderRightStyle: 'solid',
          borderRightWidth: px(1),
          borderRightColor: createRgbaColor('e6e6e6'),
          borderLeftStyle: 'solid',
          borderLeftWidth: px(1),
          borderLeftColor: createRgbaColor('e6e6e6'),
          backgroundColor: createRgbaColor('fff'),
        },
      },
    },
  },
  render: BlockContent,
  fields: {children: TListOfElement},
});

export default config;
